import React from "react";
import { Switch } from "react-router-dom";
import MenuAppBar from "../menuBar";
import AdminMenu from "../admin/menu-bar";
import AdminDashboard from "../admin";
import LoginPage from "../login";
import FilesDashboard from "../files";
import StaticContent from "../static";
import ResearchersDashboard from "../researchers/dashboard";
import Researchers from "../researchers";
import MainPage from "../main-page";
import IndicatorsDashboard from "../admin/indicators";
import IndicatorDetails from "../admin/indicators/details";
import StaticEditor from "../admin/static";
import StatsDashboard from "../stats";
import UsersDashboard from "../users";
import ResourcesDashboard from "../admin/carto/resources";
import ContainersDashboard from "../admin/carto/containers";
import LayersDashboard from "../admin/carto/layers";
import CartoStatsDashboard from "../admin/carto/stats";
import AddIndicator from "../admin/indicators/addIndicator";
import IndicatorTypes from "../admin/indicator-types";
import LandingPage from "../landing-page";
import ResourcesTags from "../tags-manager/resources-tags";
import TestPage from "../test-page";
import PrivateRoute from "./privateRoute";
import PublicRoute from "./publicRoute";
import Page404 from "../page404";

/**
 * Rutas de la aplicación
 * @author Jhoan López <jhoanlt19@gmail.com>
 */
const RoutesComponent = () => {
  return (
    <Switch>
      {/*Public Routes*/}
      <PublicRoute path="/" exact={true} component={LandingPage} />
      <PublicRoute path="/home" exact={true} component={MainPage} menu={MenuAppBar} />
      <PublicRoute path="/login/" component={LoginPage} />
      <PublicRoute path="/project/" component={StaticContent} menu={MenuAppBar} page="PROJECT" title="El Proyecto" />
      <PublicRoute path="/credits/" component={StaticContent} menu={MenuAppBar} page="CREDITS" title="Créditos" />
      <PublicRoute path="/faq/" component={StaticContent} menu={MenuAppBar} page="FAQ" title="Preguntas frecuentes" />
      <PublicRoute path="/references/" component={StaticContent} menu={MenuAppBar} page="REFERENCES" title="Citando" />
      <PublicRoute
        path="/publications/"
        component={StaticContent}
        menu={MenuAppBar}
        page="PUBLICATIONS"
        title="Publicaciones"
      />
      <PublicRoute
        path="/methodology/"
        component={StaticContent}
        menu={MenuAppBar}
        page="METHODOLOGY"
        title="Metodología"
      />
      <PublicRoute path="/researchers/" component={ResearchersDashboard} menu={MenuAppBar} />
      <PublicRoute path="/test/" component={TestPage} />

      {/*Private Routes*/}
      <PrivateRoute path="/admin/index/" component={AdminDashboard} menu={AdminMenu} />
      <PrivateRoute path="/admin/files/" component={FilesDashboard} menu={AdminMenu} />
      <PrivateRoute path="/admin/indicators/" component={IndicatorsDashboard} menu={AdminMenu} exact={true} />
      <PrivateRoute path="/admin/indicator-types/" component={IndicatorTypes} menu={AdminMenu} />
      <PrivateRoute path="/admin/resources-tags/" component={ResourcesTags} menu={AdminMenu} />
      <PrivateRoute path="/admin/indicators-details/:id/" component={IndicatorDetails} menu={AdminMenu} />
      <PrivateRoute path="/admin/indicators/add" component={AddIndicator} menu={AdminMenu} exact={true} />
      <PrivateRoute
        path="/admin/layers/:layerId/containers/"
        component={ContainersDashboard}
        menu={AdminMenu}
        exact={true}
      />
      <PrivateRoute
        path="/admin/layers/:layerId/containers/:containerId/resources"
        component={ResourcesDashboard}
        menu={AdminMenu}
        exact={true}
      />
      <PrivateRoute path="/admin/layers/:layerId/stats" component={CartoStatsDashboard} menu={AdminMenu} exact={true} />
      <PrivateRoute path="/admin/layers/" component={LayersDashboard} menu={AdminMenu} exact={true} />
      <PrivateRoute path="/admin/stats" component={StatsDashboard} menu={AdminMenu} />
      <PrivateRoute path="/admin/users" component={UsersDashboard} menu={AdminMenu} />
      <PrivateRoute path="/admin/researchers" component={Researchers} menu={AdminMenu} />
      <PrivateRoute path="/admin/static/:page" component={StaticEditor} menu={AdminMenu} />

      <PublicRoute path="/" component={Page404}/>
    </Switch>
  );
};

export default RoutesComponent;



// WEBPACK FOOTER //
// ./src/components/routes/index.js